import { useState } from "react";
import { BRAND, GradText, Section } from "../brand";
import StripePaymentStep from "../StripePaymentStep";
import CalendlyEmbed from "../CalendlyEmbed";

export default function AcceptSlide({ proposalData, isMobile, isDemo }) {
  const [step, setStep] = useState(1);
  const [pandadocOpened, setPandadocOpened] = useState(false);
  const [signed, setSigned] = useState(false);
  const [showAg, setShowAg] = useState(false);

  if (isDemo) {
    return (
      <Section style={{ background: BRAND.dark, justifyContent: "flex-start", paddingTop: isMobile ? 36 : 56, paddingBottom: isMobile ? 36 : 56, overflowY: "auto" }}>
        <div
          style={{
            position: "absolute",
            width: 600,
            height: 600,
            borderRadius: "50%",
            background:
              "radial-gradient(circle, rgba(249,115,22,0.06) 0%, transparent 70%)",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            maxWidth: 820,
            margin: "0 auto",
            width: "100%",
            zIndex: 1,
          }}
        >
          <div style={{ textAlign: "center", marginBottom: isMobile ? 16 : 20 }}>
            <h2
              style={{
                fontSize: isMobile ? 24 : 36,
                fontWeight: 800,
                color: "#fff",
                margin: 0,
                fontFamily: "'SF Pro Rounded', 'Manrope', sans-serif",
              }}
            >
              See it live in{" "}
              <GradText
                style={{
                  fontSize: isMobile ? 24 : 36,
                  fontWeight: 800,
                  fontFamily: "'SF Pro Rounded', 'Manrope', sans-serif",
                }}
              >
                your restaurant
              </GradText>
            </h2>
            <p
              style={{
                color: BRAND.gray,
                fontSize: isMobile ? 13 : 14,
                marginTop: 8,
                maxWidth: 560,
                marginLeft: "auto",
                marginRight: "auto",
                lineHeight: 1.5,
              }}
            >
              Book a 30-min call with Lucas, our CEO. He'll show you your
              restaurant's calls being answered by AI — live, in your language,
              on your menu.
            </p>
          </div>

          <div
            style={{
              background: "rgba(255,255,255,0.03)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 20,
              padding: isMobile ? "10px" : "12px 14px",
              marginBottom: 12,
            }}
          >
            <CalendlyEmbed
              calendlyUrl={proposalData.calendlyUrl}
              clientName={proposalData.clientName}
              clientEmail={proposalData.clientEmail}
            />
          </div>

          <div
            style={{
              textAlign: "center",
              padding: "12px 20px",
              borderRadius: 10,
              background: "rgba(255,255,255,0.02)",
              border: "1px solid rgba(255,255,255,0.05)",
            }}
          >
            <span style={{ fontSize: 13, color: "rgba(255,255,255,0.45)" }}>
              Prefer to talk now? Call us:{" "}
              <strong style={{ color: BRAND.orange }}>
                +1 (404) 477-4607
              </strong>
            </span>
          </div>
        </div>
      </Section>
    );
  }

  const handleOpenPandadoc = () => {
    if (proposalData.pandadocUrl) {
      window.open(proposalData.pandadocUrl, "_blank");
      setPandadocOpened(true);
    }
  };

  const handleSignConfirm = () => {
    setSigned(true);
    setTimeout(() => setStep(2), 600);
  };

  const ss = (s) => ({
    opacity: step >= s ? 1 : 0.3,
    transform: step >= s ? "scale(1)" : "scale(0.97)",
    transition: "all 0.5s ease",
    pointerEvents: step >= s ? "auto" : "none",
  });

  return (
    <Section style={{ background: BRAND.dark }}>
      <div
        style={{
          position: "absolute",
          width: 600,
          height: 600,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(249,115,22,0.06) 0%, transparent 70%)",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
        }}
      />
      <div
        style={{
          maxWidth: 740,
          margin: "0 auto",
          width: "100%",
          zIndex: 1,
        }}
      >
        <div style={{ textAlign: "center", marginBottom: isMobile ? 20 : 28 }}>
          <h2
            style={{
              fontSize: isMobile ? 28 : 42,
              fontWeight: 800,
              color: "#fff",
              margin: 0,
              fontFamily: "'SF Pro Rounded', 'Manrope', sans-serif",
            }}
          >
            Let's{" "}
            <GradText
              style={{
                fontSize: isMobile ? 28 : 42,
                fontWeight: 800,
                fontFamily: "'SF Pro Rounded', 'Manrope', sans-serif",
              }}
            >
              Get Started
            </GradText>
          </h2>
          <p
            style={{
              color: BRAND.gray,
              fontSize: isMobile ? 14 : 15,
              marginTop: 8,
            }}
          >
            Three simple steps to get started
          </p>
        </div>

        {/* Step indicators */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: isMobile ? 20 : 28,
          }}
        >
          {[1, 2, 3].map((s) => (
            <div key={s} style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  background:
                    step >= s ? BRAND.gradient : "rgba(255,255,255,0.08)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 14,
                  fontWeight: 700,
                  color: step >= s ? "#fff" : BRAND.gray,
                  transition: "all 0.4s",
                }}
              >
                {step > s ? "✓" : s}
              </div>
              {s < 3 && (
                <div
                  style={{
                    width: isMobile ? 40 : 80,
                    height: 2,
                    background:
                      step > s ? BRAND.orange : "rgba(255,255,255,0.08)",
                    transition: "all 0.4s",
                  }}
                />
              )}
            </div>
          ))}
        </div>

        {/* Step 1 — PandaDoc Review & Sign */}
        <div style={{ ...ss(1), marginBottom: 16 }}>
          <div
            style={{
              background: "rgba(255,255,255,0.03)",
              border: signed
                ? `2px solid ${BRAND.orange}40`
                : "1px solid rgba(255,255,255,0.08)",
              borderRadius: 20,
              padding: isMobile ? "18px 18px" : "22px 26px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 14,
              }}
            >
              <div
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: 12,
                  background: signed
                    ? `${BRAND.orange}20`
                    : "rgba(255,255,255,0.06)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 18,
                }}
              >
                {signed ? "✅" : "📄"}
              </div>
              <div>
                <div
                  style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}
                >
                  Step 1 — Review & Sign Your Proposal
                </div>
                <div style={{ fontSize: 12, color: BRAND.gray }}>
                  Your formal agreement is ready in PandaDoc
                </div>
              </div>
            </div>

            {signed ? (
              <div
                style={{
                  padding: 14,
                  borderRadius: 12,
                  background: `${BRAND.orange}10`,
                  textAlign: "center",
                }}
              >
                <span style={{ color: BRAND.orange, fontWeight: 600 }}>
                  ✓ Document signed
                </span>
              </div>
            ) : !pandadocOpened ? (
              proposalData.pandadocUrl ? (
                <button
                  onClick={handleOpenPandadoc}
                  style={{
                    width: "100%",
                    padding: "15px",
                    borderRadius: 14,
                    border: "none",
                    background: BRAND.gradient,
                    color: "#fff",
                    fontSize: 16,
                    fontWeight: 700,
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "translateY(-1px)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  Open Proposal to Review & Sign →
                </button>
              ) : (
                <div
                  style={{
                    padding: "16px",
                    borderRadius: 12,
                    background: "rgba(255,255,255,0.04)",
                    textAlign: "center",
                  }}
                >
                  <p
                    style={{
                      color: "rgba(255,255,255,0.5)",
                      fontSize: 14,
                      margin: 0,
                    }}
                  >
                    Your proposal document is being prepared — check your
                    email shortly.
                  </p>
                </div>
              )
            ) : (
              <div>
                <p
                  style={{
                    color: "rgba(255,255,255,0.5)",
                    fontSize: 14,
                    margin: "0 0 12px",
                    textAlign: "center",
                  }}
                >
                  Review and sign the document in the tab that just opened.
                </p>
                <div
                  style={{
                    display: "flex",
                    gap: 10,
                    flexDirection: isMobile ? "column" : "row",
                  }}
                >
                  <button
                    onClick={handleSignConfirm}
                    style={{
                      flex: 1,
                      padding: "13px 20px",
                      borderRadius: 12,
                      border: "none",
                      background: BRAND.gradient,
                      color: "#fff",
                      fontSize: 15,
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    I've Signed the Document ✓
                  </button>
                  <button
                    onClick={handleOpenPandadoc}
                    style={{
                      padding: "13px 20px",
                      borderRadius: 12,
                      border: "1px solid rgba(255,255,255,0.12)",
                      background: "rgba(255,255,255,0.04)",
                      color: BRAND.gray,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    Re-open PandaDoc
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Step 2 — Pay */}
        <div style={{ ...ss(2), marginBottom: 16 }}>
          <div
            style={{
              background: "rgba(255,255,255,0.03)",
              border:
                step > 2
                  ? `2px solid ${BRAND.pink}40`
                  : "1px solid rgba(255,255,255,0.08)",
              borderRadius: 20,
              padding: isMobile ? "18px 18px" : "22px 26px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 14,
              }}
            >
              <div
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: 12,
                  background:
                    step > 2
                      ? `${BRAND.pink}20`
                      : "rgba(255,255,255,0.06)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 18,
                }}
              >
                {step > 2 ? "✅" : "💳"}
              </div>
              <div>
                <div
                  style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}
                >
                  Step 2 — Activate Your Account
                </div>
                <div style={{ fontSize: 12, color: BRAND.gray }}>
                  Setup fee: {proposalData.setupFee || "$499"} via Stripe
                </div>
              </div>
            </div>
            {step > 2 ? (
              <div
                style={{
                  padding: 14,
                  borderRadius: 12,
                  background: `${BRAND.pink}10`,
                  textAlign: "center",
                }}
              >
                <span style={{ color: BRAND.pink, fontWeight: 600 }}>
                  ✓ Payment Complete
                </span>
              </div>
            ) : step === 2 ? (
              <StripePaymentStep
                stripeLinks={proposalData.stripeLinks}
                setupFee={proposalData.setupFee}
                onComplete={() => setStep(3)}
              />
            ) : (
              <button
                disabled
                style={{
                  width: "100%",
                  padding: "15px",
                  borderRadius: 14,
                  border: "none",
                  background: "rgba(255,255,255,0.06)",
                  color: "#fff",
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: "default",
                }}
              >
                Pay Setup Fee via Stripe →
              </button>
            )}
          </div>
        </div>

        {/* Step 3 — Schedule */}
        <div style={{ ...ss(3), marginBottom: 14 }}>
          <div
            style={{
              background: "rgba(255,255,255,0.03)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 20,
              padding: isMobile ? "18px 18px" : "22px 26px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 14,
              }}
            >
              <div
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: 12,
                  background: "rgba(255,255,255,0.06)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 18,
                }}
              >
                📅
              </div>
              <div>
                <div
                  style={{ fontSize: 17, fontWeight: 700, color: "#fff" }}
                >
                  Step 3 — Book Your Onboarding Call
                </div>
                <div style={{ fontSize: 12, color: BRAND.gray }}>
                  We have immediate availability
                </div>
              </div>
            </div>
            {step === 3 ? (
              <CalendlyEmbed
                calendlyUrl={proposalData.calendlyUrl}
                clientName={proposalData.clientName}
                clientEmail={proposalData.clientEmail}
              />
            ) : (
              <button
                disabled
                style={{
                  width: "100%",
                  padding: "15px",
                  borderRadius: 14,
                  border: "none",
                  background: "rgba(255,255,255,0.06)",
                  color: "#fff",
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: "default",
                }}
              >
                Schedule Onboarding Call →
              </button>
            )}
          </div>
        </div>

        {/* CSM */}
        <div
          style={{
            textAlign: "center",
            padding: "10px 20px",
            borderRadius: 10,
            background: "rgba(255,255,255,0.02)",
            border: "1px solid rgba(255,255,255,0.05)",
            marginBottom: 12,
          }}
        >
          <span
            style={{ fontSize: 12, color: "rgba(255,255,255,0.35)" }}
          >
            Need to speak with someone now? Call our CSM 24/7:{" "}
            <strong style={{ color: BRAND.orange }}>
              +1 (404) 477-4607
            </strong>
          </span>
        </div>

        {/* Agreement */}
        <button
          onClick={() => setShowAg(!showAg)}
          style={{
            width: "100%",
            padding: "12px 20px",
            borderRadius: 12,
            border: "1px solid rgba(255,255,255,0.08)",
            background: "rgba(255,255,255,0.02)",
            color: BRAND.gray,
            fontSize: 13,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span>📄 View Full Agreement Details</span>
          <span
            style={{
              transform: showAg ? "rotate(180deg)" : "rotate(0)",
              transition: "transform 0.3s",
            }}
          >
            ▼
          </span>
        </button>
        {showAg && (
          <div
            style={{
              marginTop: 8,
              padding: isMobile ? "18px 18px" : "24px 28px",
              borderRadius: 16,
              background: "rgba(255,255,255,0.03)",
              border: "1px solid rgba(255,255,255,0.08)",
              fontSize: 12.5,
              color: "rgba(255,255,255,0.55)",
              lineHeight: 1.7,
              maxHeight: 500,
              overflowY: "auto",
            }}
          >
            <h3
              style={{
                color: "#fff",
                fontSize: 17,
                fontWeight: 700,
                margin: "0 0 6px",
              }}
            >
              RestoHost AI — Service Agreement
            </h3>
            <p
              style={{
                fontSize: 11,
                color: BRAND.gray,
                marginBottom: 16,
              }}
            >
              Effective Date: {proposalData.date}
            </p>
            <p>
              <strong style={{ color: "#fff" }}>Parties:</strong> Resto
              Host Inc (d/b/a "RestoHost AI"), Delaware corp., 8 The Green
              Suite R, Dover DE 19901 and{" "}
              {proposalData.clientName || "[Client]"} ("Client").
            </p>
            <h4
              style={{
                color: BRAND.orange,
                fontSize: 14,
                margin: "16px 0 6px",
              }}
            >
              1 · Scope of Services
            </h4>
            <p>
              Executive Plan: AI Call Handling 24/7 (100 simultaneous,
              multilingual), Fully-Custom AI Host, Priority Support
              (WhatsApp + CSM), Customer-Support Form Automation, Advanced
              Analytics & Reports, Unlimited Staff Transfers. Optional
              Add-Ons available.
            </p>
            <h4
              style={{
                color: BRAND.orange,
                fontSize: 14,
                margin: "16px 0 6px",
              }}
            >
              2 · Onboarding & 90-Day Evaluation
            </h4>
            <p>
              Days 0-7: Kickoff. Days 8-21: Creation & Training. Days
              22-28: Testing Sprint. Day 29-30: Final Fixes & Go-Live.
              Billing starts Day 30. Client may cancel during 90-day
              evaluation with written notice — no further fees.
            </p>
            <p>
              After evaluation: 12-month Initial Term, auto-renews for
              12-month periods unless 60 days' notice.
            </p>
            <h4
              style={{
                color: BRAND.orange,
                fontSize: 14,
                margin: "16px 0 6px",
              }}
            >
              4 · Fees and Payment
            </h4>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                gap: 8,
                marginBottom: 10,
              }}
            >
              {[
                { l: "Locations", v: proposalData.locations },
                { l: "Setup Fee", v: proposalData.setupFee },
                { l: "Monthly", v: proposalData.monthlyFee },
                { l: "Add-Ons", v: proposalData.addOns || "N/A" },
              ].map((f, i) => (
                <div
                  key={i}
                  style={{
                    padding: "8px 12px",
                    borderRadius: 8,
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(255,255,255,0.06)",
                  }}
                >
                  <div
                    style={{
                      fontSize: 10,
                      color: BRAND.gray,
                      textTransform: "uppercase",
                      letterSpacing: 1,
                    }}
                  >
                    {f.l}
                  </div>
                  <div
                    style={{
                      fontSize: 14,
                      color: "#fff",
                      fontWeight: 600,
                    }}
                  >
                    {f.v || "—"}
                  </div>
                </div>
              ))}
            </div>
            <p>
              ACH auto-debit first business day monthly. Failed ACH:
              1.5%/month interest.
            </p>
            <h4
              style={{
                color: BRAND.orange,
                fontSize: 14,
                margin: "16px 0 6px",
              }}
            >
              5-9 · Legal Terms
            </h4>
            <p>
              Confidentiality, Compliance (two-party consent provided), IP
              (RestoHost owns platform; Client owns content),
              Indemnification (direct damages), Liability cap: greater of
              $250K or 12mo fees.
            </p>
            <h4
              style={{
                color: BRAND.orange,
                fontSize: 14,
                margin: "16px 0 6px",
              }}
            >
              10 · Early Termination
            </h4>
            <p>
              30 days' notice + fee equal to 2 months avg subscription.
              Termination for cause: 30 days' notice, 15 days cure.
            </p>
            <h4
              style={{
                color: BRAND.orange,
                fontSize: 14,
                margin: "16px 0 6px",
              }}
            >
              12-13 · Governing Law & Entire Agreement
            </h4>
            <p>Delaware law. This Agreement + order forms = entire agreement.</p>
            <div
              style={{
                marginTop: 16,
                padding: "14px",
                borderRadius: 10,
                background: "rgba(255,255,255,0.02)",
                border: "1px solid rgba(255,255,255,0.06)",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 8,
              }}
            >
              <img
                src="/logos/RH-SVG-2.svg"
                alt="RestoHost"
                style={{ height: 18, width: "auto", display: "block" }}
              />
              <p
                style={{
                  margin: 0,
                  fontSize: 11,
                  color: BRAND.gray,
                }}
              >
                RestoHost Inc
              </p>
            </div>
          </div>
        )}
      </div>
    </Section>
  );
}
